export default __webpack_public_path__ + "static/media/ice.fb890b12.jpg";